import React, { useState, useEffect } from "react";


const Page6 = () => {

  const [mostraTexto2, setMostraTexto2] = useState({});

  function toggleTexto2(chave) {
    setMostraTexto2((prev) => ({
      ...prev,
      [chave]: !prev[chave],
    }));
  }


  return (
    <div className="page-container">
            <p style={{ color: "#000000", fontSize: '18px' }}>Independentemente do tipo, uma mudança pode se manifestar de diferentes maneiras, por exemplo:</p>
            <br /> 
            <div className="cards-grid" style={{ justifyContent: 'center' }}>
              {[
                { id: 1, titulo: "Mudanças Técnicas", descricao: "alterações em equipamentos, instalações, processos, parâmetros operacionais ou controles."},
                { id: 2, titulo: "Mudanças Organizacionais", descricao: "alterações em estrutura, responsabilidades, equipes ou formas de trabalho."},
                { id: 3, titulo: "Mudanças de Informação ", descricao: "alterações em procedimentos, instruções de trabalho, desenhos, sistemas ou documentos."},
                { id: 4, titulo: "Operações infrequentes", descricao: "novas operações não rotineiras devem seguir o procedimento de MOC."},
                { id: 5, titulo: "Mudanças complexas", descricao: "Mudança que é um projeto maior ou que requer uma avaliação de risco mais detalhada. Normalmente requer A2, A3 e A4."}
              ].map((epi) => (
                <div className="col-md-8" key={epi.id} style={{ margin: "20px" }}>
                  <div
                    className="card-container"
                    onClick={() => toggleTexto2(`epi${epi.id}`)}
                    style={{ position: "relative" }} // referência da seta
                  >
                    {/* SETA PULSANTE — apenas no primeiro card e quando fechado */}
                    {/* {epi.id === 1 && !mostraTexto2[`epi${epi.id}`] } */}

                    <div
                      className={`card ${mostraTexto2[`epi${epi.id}`] ? "flipped" : ""}`}
                      style={{
                        border: "none",
                        minHeight: "200px",
                        borderRadius: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {/* FACE DA FRENTE */}
                      <div className="card-face card-front">
                        <div
                          className="inner"
                          style={{
                            backgroundColor: "#f0f0f0",
                            borderRadius: "15px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >                     
                        <p
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#333",
                          }}
                        >
                          {epi.titulo}
                        </p>
                        </div>
                      </div>

                      {/* FACE DE TRÁS */}
                      <div className="card-face card-back">
                        <div
                          className="inner"
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              textAlign: "center",
                              color: "#444",
                              padding: "0 10px",
                            }}
                          >
                            {epi.descricao}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              ))}

            </div>
            <p style={{ color: "#000000", textAlign: 'center', fontSize: '18px' }}>Independentemente do tipo, uma mudança pode se manifestar de diferentes maneiras, por exemplo:</p>


      <style>{`
        .page-container {
          width: 100%;
          height: calc(100vh - 50px);
          display: flex;
          flex-direction: column;
          padding: 15px;
          box-sizing: border-box;
          background: #ffffff;
          overflow: hidden;
        }

        /* TEXTOS SUPERIOR E INFERIOR */
        .page-container > p {
          text-align: center;
          font-size: 14px;
          margin: 5px 0;
        }

        /* GRID PRINCIPAL */
        .cards-grid {
          flex: 1;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          align-items: stretch;
        }

        /* CARD CONTAINER */
        .card-container {
          height: 100%;
          position: relative;
        }

        /* CARD BASE */
        .card {
          height: 100%;
          border-radius: 12px;
          cursor: pointer;
          border: none;
          perspective: 1000px;
        }

        /* FACES DO CARD */
        .card-face {
          position: absolute;
          width: 100%;
          height: 85%;
          backface-visibility: hidden;
          border-radius: 12px;
        }

        /* FRENTE */
        .card-front .inner {
          background: #f1f5f9;
        }

        /* VERSO */
        .card-back {
          transform: rotateY(180deg);
        }

        .card-back .inner {
          background: #ffffff;
        }

        /* ANIMAÇÃO FLIP */
        .card {
          position: relative;
          transform-style: preserve-3d;
          transition: transform 0.5s;
        }

        .card.flipped {
          transform: rotateY(180deg);
        }

        /* CONTEÚDO INTERNO */
        .inner {
          height: 100%;
          padding: 35px;
          border-radius: 12px;

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        /* IMAGEM */
        .inner img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-bottom: 8px;
        }

        /* TÍTULO */
        .inner p {
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          color: #334155;
          margin: 0;
        }

        /* TEXTO DO VERSO */
        .card-back p {
          font-size: 13px;
          font-weight: normal;
          color: #475569;
        }

        /* RESPONSIVO */
        @media (max-width: 900px) {
          .cards-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .cards-grid {
            grid-template-columns: 1fr;
          }

          .page-container > p {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default Page6;